module.exports = __webpack_public_path__ + "img/AS.02731a48.svg";